import { render, staticRenderFns } from "./ContractChatForm.vue?vue&type=template&id=997d9db2&scoped=true&lang=pug"
import script from "./ContractChatForm.vue?vue&type=script&lang=js"
export * from "./ContractChatForm.vue?vue&type=script&lang=js"
import style0 from "./ContractChatForm.vue?vue&type=style&index=0&id=997d9db2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "997d9db2",
  null
  
)

export default component.exports